import { createContext, useState, useEffect, useContext } from "react"
import { validToken } from "../services/Auth"
import { useNavigate, useLocation } from "react-router-dom"

export const AuthContext = createContext()
export const useAuthSession = () => useContext( AuthContext )

const exclude = [ "/login" ]

const sleep = ( ms ) => {
  return new Promise( ( resolve ) => setTimeout( resolve, ms ) )
}

export default function AuthContextProvider( { children } ) {
  const [ loading, setLoading ] = useState( true )
  const navigate = useNavigate()
  const location = useLocation()

  const [ dataUser, setDataUser ] = useState( {} )
  const [ company, setCompany ] = useState( {} )

  useEffect( () => {
    if ( !exclude.includes( location.pathname ) ) getData()
    else setLoading( false )
  }, [] )

  const redirecTO = async () => {
    await sleep( 200 )
    navigate( "/login" )
  }

  const getData = async () => {
    try {
      setLoading( true )
      const res = await validToken()

      if ( res ) {
        setCompany( res.company )
        setDataUser( res.user )
      } else {
        await redirecTO()
      }
    } catch ( error ) {
      await redirecTO()
    } finally {
      setLoading( false )
    }
  }

  const changeEmpresa = ( value ) => {
    localStorage.setItem( 'company', value )
    window.location.reload()
  }

  return (
    <AuthContext.Provider
      value={{
        dataUser, company, setCompany, loading, changeEmpresa
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
